import axios from "axios";
import {Message} from "element-ui";
import {getToken} from "@/utils/cache";
import {baseUrl} from "@/utils/config";
import router from "@/router";
import qs from 'qs'

const http = axios.create({
    baseURL: baseUrl,
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

// 请求拦截器
http.interceptors.request.use((config) => {
    let token = getToken()
    if (token) {
        config.headers.token = token
    }


    // 如果是POST请求且数据是对象，使用qs序列化
    if (config.method === 'post' && config.data && typeof config.data === 'object') {
        // config.data.platform = 'pc'
        config.data = qs.stringify(config.data)
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use((response) => {
    let result = response.data
    return new Promise((resolve, reject) => {
        if (result.code == 0) {
            Message({
                type: 'error',
                message: result.msg || '请求失败'
            })
            return reject(result);
        } else if (result.code == 1) {
            return resolve(result)
        } else {
            Message({
                type: 'error',
                message: result.msg || '未知错误'
            })
            return reject(result)
        }
    })
}, (error) => {

    if (error.response) {
        const {status, data} = error.response
        if (status === 401) {
            router.push(`/login`)
            Message.error(data.msg || '登录已过期，请重新登录')
            return Promise.reject(data.msg)
        } else if (status === 403) {
            Message.error('没有权限访问该资源')
            return Promise.reject('没有权限')
        } else if (status === 404) {
            Message.error('请求的资源不存在')
            return Promise.reject('资源不存在')
        } else if (status >= 500) {
            Message.error('服务器内部错误')
            return Promise.reject('服务器错误')
        }
    } else if (error.code === 'ECONNABORTED') {
        Message.error('请求超时，请检查网络连接')
        return Promise.reject('请求超时')
    } else {
        Message.error('网络错误，请检查网络连接')
        return Promise.reject('网络错误')
    }

    return Promise.reject(error)
})

// GET 请求
export const get = (url, params = {}, config = {}) => {
    return http.get(url, {
        params,
        ...config
    })
}

// POST 请求
export const post = (url, data = {}, config = {}) => {
    return http.post(url, data, config)
}

// PUT 请求
export const put = (url, data = {}, config = {}) => {
    return http.put(url, data, config)
}

// DELETE 请求
export const del = (url, config = {}) => {
    return http.delete(url, config)
}

// 文件上传
export const upload = (url, file, config = {}) => {
    const formData = new FormData()
    formData.append('file', file)

    return http.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        ...config
    })
}

// 批量上传
export const uploadMultiple = (url, files, config = {}) => {
    const formData = new FormData()
    files.forEach((file, index) => {
        formData.append(`file${index}`, file)
    })

    return http.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        ...config
    })
}

// 下载文件
export const download = (url, params = {}, filename = '') => {
    return http.get(url, {
        params,
        responseType: 'blob'
    }).then(response => {
        const blob = new Blob([response.data])
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = filename || 'download'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)
        return response
    })
}

// 创建请求实例（用于特殊配置）
export const createRequest = (config = {}) => {
    return axios.create({
        baseURL: baseUrl,
        timeout: 5000,
        ...config
    })
}

export default http



